import React, { Component } from 'react';
import axios from 'axios';
import { Breadcrumb, Heading } from '../common/atoms';
import { RatingsManager, UtilizationGraphManager, ContractsManager, WalletUtilizationManager  } from '../../managers';
import { handleAppError, setLocalStorage } from '../handlers';
import { utilizationApi } from '../../services';
import { VaccinationLocked, VaccinationLow } from '../../assets/images';
import { UtilizationLockScreen, NoUtilizationCard, } from '../common/organisms';
import { VACCINATION_LOCKED_CONTENT, TOTAL_VACCINATIONS, FILTER } from '../../constants/utilization';
import {Vaccination} from '../common/templates/Utilization';
import { PeriodPicker } from '../common/molecules';
import Skeleton from 'react-loading-skeleton';
import OverallSection from './Vaccination/OverallSection';
import moment from 'moment';
import DateRangePicker from '../tailwind/molecules/DateRangePicker';
import { SALES_ROLE } from '../../constants/overview';
import { dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles';
let source = '';

class VaccinationPage extends Component {
  constructor(props) {
    super(props);
    const query = window.location.search;
    this.state = {
      selectedContractObj: {},
      metricObj: {},
      utilizationObj: {},
      futureAppObj: {},
      ratingObj: {},
      benefitName: 'Vaccination',
      walletUtilizationObj: {},
      loading: true,
      showNoUtilization: false,
      totalEmployees: null,
      showSubheading: true,
      filterDates: {startDate: null, endDate: null}
    };
    
  }

  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        var contractObj = new ContractsManager(resp.data, 'VACCINATION');
        this.setState({
          contractObj,
          selectedContractObj: contractObj.formattedData[0],
          contractId: contractObj.formattedData[0].contract_id,
          totalCustomers: contractObj.formattedData[0].total_customers,
          showSubheading: contractObj.formattedData[0].text !== 'Overall',
          overAllId : contractObj.formattedData[0].contract_id,
          filterDates: { startDate: contractObj.formattedData[0]?.start_date, endDate: contractObj.formattedData[0]?.end_date }
        });
      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  fetchCompleteData = (contractId, startDate, endDate) => {
    this.setState({loading : true});
    this.setState({loading: true })
    let start_date = startDate ? startDate : this.state.selectedContractObj.start_date
    let end_date = endDate ? endDate : this.state.selectedContractObj.end_date
    start_date =  moment(start_date).format('YYYY-MM-DD')
    end_date =  moment(end_date).format('YYYY-MM-DD')
    source = axios.CancelToken.source();
    var promise1 = utilizationApi.vaccinationFetchMetrics({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: source.token });
    var promise2 = utilizationApi.vaccinationFetchRatings({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: source.token });
    var promise3 = utilizationApi.vaccinationFetchFutureAppointments({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: source.token });
    var promise4 = utilizationApi.vaccinationFetchUtilizationGraph({
      contractId: contractId,
      filter: 'age',
      startDate: start_date,
      endDate: end_date, 
      cancelToken: source.token,
    });
    var promise5 = utilizationApi.walletBenefitUtilization({ contractId, benefit_type : 'flu_vaccination', startDate: start_date, endDate: end_date })

    Promise.all([promise1, promise2, promise3, promise4, promise5])
    .then((values) => {
        var resp_arr = values.map((resp) => resp.data);
        var metricObj = resp_arr[0];
        setLocalStorage(TOTAL_VACCINATIONS, metricObj.total_vaccination + metricObj.total_dependent);
        var ratingObj = new RatingsManager(resp_arr[1]);
        var futureAppObj = resp_arr[2];
        var utilizationObj = new UtilizationGraphManager(resp_arr[3]);
        utilizationObj.xAxesLabel = 'Age';
        var walletUtilizationObj = new WalletUtilizationManager(resp_arr[4]);
        walletUtilizationObj.xAxesLabelWallet = 'Months';
      
        var showNoUtilization = (metricObj.total_vaccination || metricObj.total_dependent || futureAppObj.total_vaccination || futureAppObj.total_dependent) === 0;
        this.setState({
          metricObj,
          ratingObj,
          futureAppObj,
          utilizationObj,
          loading: false,
          showNoUtilization,
          walletUtilizationObj
        });
    })
    .catch((err) => handleAppError(err));
  };

  getUtilizationBarData = ({ filter, xAxesLabel }) => {
    let utilizationObj = { barlabels: [], bardata: [], barBgColors: [], xAxesLabel: xAxesLabel };
    utilizationApi.vaccinationFetchUtilizationGraph(
      { filter: filter, contractId: this.state.contractId, startDate: this.state.filterDates.startDate, endDate: this.state.filterDates.endDate },
      (resp) => {
        utilizationObj = new UtilizationGraphManager(resp.data, filter);
        utilizationObj.xAxesLabel = xAxesLabel;
        this.setState({ utilizationObj });
      },
      (err) => {
        this.setState({ utilizationObj });
        handleAppError(err);
      }
    );
  };

  componentDidMount = () => {
    this.fetchContractDetails();
  };

  componentWillUnmount() {
    source && source.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if ((this.state.contractId && prevState.contractId !== this.state.contractId) || (this.state.filterDates.startDate && prevState.filterDates.startDate !== this.state.filterDates.startDate) || (this.state.filterDates.endDate && prevState.filterDates.endDate !== this.state.filterDates.endDate)) {
      source && source.cancel();
      this.state.selectedContractObj.enable_vaccination ? this.fetchCompleteData(this.state.contractId, this.state.filterDates.startDate, this.state.filterDates.endDate) : this.setState({loading : false})    
    }
  }

  toggleHelp = () => this.props.toggleHelp('Vaccination');

  getContent = (selectedContractObj) => {
    const { loading, showNoUtilization, overAllId } = this.state;
    if (selectedContractObj.text === 'Overall') {
      source && source.cancel();
      source = axios.CancelToken.source();
      return <OverallSection contractId={overAllId} token={source} />;
    } 

    else if(selectedContractObj.enable_vaccination){ 
      return (
        showNoUtilization ? (
          <NoUtilizationCard
            line='utilization of the vaccination sponsored by the company or paid by the employees'
            imgsrc={VaccinationLow}
            toggleHelp={this.toggleHelp}
            classes='mt-8'
          />
        ) : (<Vaccination {...this.state} sqaureTabHandler={(type) => this.getUtilizationBarData(FILTER[type])} /> 
      ));
    }  
    else {
      return (
        <div className='mt-8'>
          <UtilizationLockScreen
            sectionTitle='Vaccination is not enabled'
            image={VaccinationLocked}
            sectionSubtitle='Benefits to your employees'
            points={VACCINATION_LOCKED_CONTENT}
            toggleHelp={this.toggleHelp}
          />
        </div>
      );
    }
  };
  navigateToActivityLog = () => {
    const { start_date, end_date, contract_id } = this.state.selectedContractObj
    this.props.history.push('/activity-log?point=vaccination', { start_date, end_date, contract_id });
  };
  
  changeContractId = (contract) => {
    const { contractId } = this.state;
    const { contract_id } = contract;
   if (contract.text === 'Overall') {
      this.setState({
        contractId: contractId,
        selectedContractObj: contract,
        loading: false,
        filterDates: {startDate: null, endDate: null}
      });
      this.props.history.push('/vaccination')
    }
    else {
      this.setState({
        contractId: contract_id,
        selectedContractObj: contract,
        loading: false,
        filterDates: {startDate: contract?.start_date, endDate: contract?.end_date}
      });
      this.props.history.push('/vaccination')
    }
  };

  changeDates = (e, date_type) =>{
    let date = moment(e).format('YYYY-MM-DD')
    if (e){
      if (date_type === 'startDate'){
        this.setState({filterDates: {...this.state.filterDates, startDate: date}})
      }
      else if(date_type === 'endDate') {
        this.setState({filterDates: {...this.state.filterDates, endDate: date}})
      }
      else if(date_type === 'reset'){
        this.setState({filterDates: {startDate: moment(this.state.selectedContractObj?.start_date)}, endDate: moment(this.state.selectedContractObj?.end_date)})
      }
    }
    else{
      if (date_type === 'startDate'){
        this.setState({filterDates: {...this.state.filterDates, startDate: moment(this.state.selectedContractObj.start_date).format('YYYY-MM-DD')}})
      }
      else {
        this.setState({filterDates: {...this.state.filterDates, endDate: moment(this.state.selectedContractObj.end_date).format('YYYY-MM-DD')}})
      }
    }
  };


  render() {
    const { contractObj, loading } = this.state;
    const formattedData = contractObj ? contractObj.formattedData : null;
    return (
      <div className='min-w-0'>
        {loading ? (
          <Skeleton width='100%' height={100} />
        ) : (
          <>
            <div className='flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between'>
              <div className='min-w-0'>
                <Breadcrumb
                  list={[
                    { text: 'Utilization', link: '/utilization/ahc' },
                    { text: 'Vaccination', link: '/vaccination' },
                  ]}
                  classes='mb-1'
                />
                {typeof this.state.selectedContractObj !== 'undefined' && (
                  <Heading
                    mainHeading='Utilization of Vaccination'
                    mainClasses='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl'
                  />
                )}
              </div>
              <div className='flex shrink-0 flex-wrap items-end gap-2 lg:justify-end'>
                {/* Period control joins the existing action group, bottom-aligned so the control and the button
                    share a baseline. The separate "Contract period / year" caption is gone with it: the picker
                    states that itself. */}
                <PeriodPicker
                  list={formattedData}
                  loading={loading}
                  currentPage={this.state.selectedContractObj?.text}
                  setContract={this.changeContractId}
                />
                <button
                  type='button'
                  onClick={this.navigateToActivityLog}
                  disabled={SALES_ROLE === 'sales'}
                  className={joinButtonClasses(dsButtonPrimary, 'h-10 px-5', SALES_ROLE === 'sales' && 'cursor-not-allowed')}
                >
                  Activity Log
                </button>
              </div>
            </div>
          </>
        )}
        {contractObj && (
          <div className='mt-3'>
            <DateRangePicker
              filterDates={this.state.filterDates}
              isOverAll={this.state.selectedContractObj?.is_overall_contract}
              contractDates={[this.state.selectedContractObj?.start_date, this.state.selectedContractObj?.end_date]}
              changeDates={this.changeDates}
            />
          </div>
        )}
        {this.getContent(this.state.selectedContractObj)}
      </div>
    );
  }
}

export default VaccinationPage;
